export default __webpack_public_path__ + "media/images/feather_sprite-c2085526f54bc72bc1535ae7dbdcce3d.png";